import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  infoUtente: {},
  isMobile:
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    ),
  isOpenDrawer:
    !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    ),
}

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    resetHome: () => initialState,
    setInfoUtente(state, action) {
      state.infoUtente = action.payload
    },
    setImpostazioniContatti(state, action) {
      state.impostazioniContatti = action.payload
    },
    setImpostazioniMail(state, action) {
      state.impostazioniMail = action.payload
    },
    setImpostazioniAlgoritmi(state, action) {
      state.impostazioniAlgoritmi = action.payload
    },
    setImpostazioniAvanzate(state, action) {
      state.impostazioniAvanzate = action.payload
    },
    setOptimisticBackendR(state, action) {
      state.optimisticBackendR = action.payload
    },
    setTabelloni(state, action) {
      state.tabelloni = action.payload
    },
    setError(state, action) {
      state.error = action.payload
    },
    setFeedback(state, action) {
      state.feedback = action.payload
    },
    setIsMobile(state, action) {
      state.isMobile = action.payload
    },
    setIsOpenDrawer(state, action) {
      state.isOpenDrawer = action.payload
    },
  },
})

export const {
  resetHome,
  setInfoUtente,
  setImpostazioniContatti,
  setImpostazioniMail,
  setImpostazioniAlgoritmi,
  setImpostazioniAvanzate,
  setOptimisticBackendR,
  setTabelloni,
  setError,
  setFeedback,
  setIsMobile,
  setIsOpenDrawer,
} = homeSlice.actions

export default homeSlice.reducer
